module.exports = global["Selectize"] = require("-!./selectize.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?Selectize!../node_modules/selectize/dist/js/selectize.js-exposed
// module id = 544
// module chunks = 3